import * as React from "react";
import { forwardRef } from "react";
const LogoYandexSVG = (props, ref) => React.createElement("svg", { width: 32, height: 32, fill: "none", viewBox: "0 0 32 32", ref: ref, ...props },
    React.createElement("path", { fill: "#FC3F1D", d: "M16 32c8.837 0 16-7.163 16-16S24.837 0 16 0 0 7.163 0 16s7.163 16 16 16" }),
    React.createElement("path", { fill: "#fff", d: "M18.318 26V8.707h-1.64c-3.007 0-4.582 1.428-4.582 3.559 0 2.417 1.086 3.537 3.334 4.965l1.852 1.185L12 25.997H8l4.79-6.768c-2.754-1.868-4.304-3.691-4.304-6.768C8.486 8.616 11.309 6 16.653 6h5.322L22 26z" }));
const ForwardRef = forwardRef(LogoYandexSVG);
export default ForwardRef;
//# sourceMappingURL=LogoYandex.js.map